export default function(Vue) {
  Vue.auth = {
    setToken: (data) => {
      localStorage.setItem('auth-user', JSON.stringify(data))
    },
    getRole: () => {
      var authUser = JSON.parse(localStorage.getItem('auth-user'))
      if (authUser != null) {
        return authUser.role
      }
      return null
    },
    getToken: () => {
      var authUser = JSON.parse(localStorage.getItem('auth-user'))
      var token = null
      var expiration = null
      if (authUser != null) {
        token = authUser.access_token
        expiration = authUser.expires_in
      }
      if (!token || !expiration) return null
      if (Date.now() < parseInt(expiration)) {
        this.destroyToken()
        return null
      } else {
        return token
      }
    },
    getUserID: () => {
      var authUser = JSON.parse(localStorage.getItem('auth-user'))
      var token = null
      var expiration = null
      var userId = null
      if (authUser != null) {
        token = authUser.access_token
        expiration = authUser.expires_in
        userId = authUser.id
      }

      if (!token || !expiration || !userId) return null

      if (Date.now() < parseInt(expiration)) {
        this.destroyToken()
        return null
      } else return userId
    },
    getUser: () => {
      var authUser = JSON.parse(localStorage.getItem('auth-user'))
      if (authUser != null) {
        const firstName = authUser.first_name
        const lastName = authUser.last_name
        const email = authUser.email
        const id = authUser.id
        return {id, email, firstName, lastName}
      }
      return null
    },
    destroyToken: () => {
      localStorage.removeItem('auth-user')
      localStorage.removeItem('google-token')
      window.location.reload()
    },

    isAuthenticated: () => {
      var authUser = JSON.parse(localStorage.getItem('auth-user'))
      var expiration = null
      if (authUser != null) {
        expiration = authUser.expires_in
      } else {
        return false
      }
      if (!expiration) { return false }
      if (Date.now() < parseInt(expiration)) {
        localStorage.removeItem('auth-user')
        window.location.reload()
        return false
      } else return true
    },
    getUserImg: () => {
      var authUser = JSON.parse(localStorage.getItem('auth-user'))
      if (authUser != null) {
        const img = authUser.image
        return img
      }
      return null
    },
    setGoogleToken: (data) => {
      localStorage.setItem('google-token', data)
    },
    getGoogleToken: () => {
      const token = localStorage.getItem('google-token')
      // localStorage.getItem('google-token', data)
      return token
    },
    setGoogleRefreshToken: (data) => {
      localStorage.setItem('google-refresh-token', data)
    },
    getGoogleRefreshToken: (data) => {
      localStorage.getItem('google-refresh-token', data)
    },
    removeGoogleToken: () => {
      localStorage.removeItem('google-token')
    }
  }
  Object.defineProperties(Vue.prototype, {
    $auth: {
      get: () => {
        return Vue.auth
      }
    }
  })
}



// WEBPACK FOOTER //
// ./src/packages/auth/auth.js